import * as React from 'react';

import { createClient, type Client } from '@connectrpc/connect';
import { SidecarLocalService } from '@rematter/frontend-lib-api-client/grpc/sidecar/v1/local_api_pb';

import { useLibp2p } from './useLibp2p';

export type SidecarClient = Client<typeof SidecarLocalService>;

export function useSidecarClient(sidecarId: string): SidecarClient | null {
  const { getTransport, connections } = useLibp2p();

  const isConnected = connections.get(sidecarId)?.connected ?? false;

  return React.useMemo(() => {
    if (!isConnected) return null;

    const transport = getTransport(sidecarId);
    if (!transport) return null;

    return createClient(SidecarLocalService, transport);
  }, [sidecarId, getTransport, isConnected]);
}
